import { black, darkOrange, textMuted, warmTint } from '@/theme/colors'
import { fontBody, fontDisplay } from '@/theme/fonts'
import { breakpoints, radii } from '@/theme/tokens'
import styled from 'styled-components'
import Thumbnail from './Thumbnail'

/**
 * Stacked stay rows (design `.bento-rows`): always top-aligned with a fixed
 * gap, so adding a third stay never re-spaces the first two — rows keep the
 * same rhythm at any count and leftover tile height stays at the bottom.
 */
export const StayRows = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`

/** One stay row: 92×92 photo + text block (design `.bento-media-row`). */
export const StayRow = styled.div`
	display: flex;
	gap: 14px;
	align-items: center;
	min-width: 0;
`

export const StayThumb = styled(Thumbnail)`
	width: 92px;
	height: 92px;

	@media (max-width: ${breakpoints.phone}px) {
		width: 72px;
		height: 72px;
	}
`

export const StayText = styled.div`
	min-width: 0;
`

export const StayName = styled.div`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 15px;
	color: ${black};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export const StayCity = styled.div`
	font-family: ${fontBody};
	font-size: 12.5px;
	color: ${textMuted};
	margin-top: 2px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

/** Warm date chip "check-in → check-out" (design `.bento-date-chip`). */
export const StayDateChip = styled.div`
	display: inline-block;
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 11.5px;
	color: ${darkOrange};
	background: ${warmTint};
	border-radius: ${radii.pill};
	padding: 3px 10px;
	margin-top: 5px;
	white-space: nowrap;
`
